import React, { Component } from "react";
import { Button } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Grid, Row, Col } from "@vds/grids";
import { Notification } from '@vds/notifications';
import { Input, CheckboxGroup, RadioButtonGroup } from "@vds/inputs";
import NavHeader from '../../Common/NavHeader/NavHeader';
import common, { Privacy, refreshChatHashTag } from "../../utils/common";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from "./containers/actions";
import "./SaveCart.css";
import { TextLink } from '@vds/buttons';
import Icon from '@vds/icons';
import * as SiteAnalytics from '../../sitecatalyst';
// import * as ChatAnalytics from '../../utils/lpchatMetrics';
import { getChatInfo } from './containers/actions';
import { getRetrieveCartInfo, updatePageLoadType, updateIsCheckoutPageVisited, updateIsSaveCartPageVisited, setSaveCartDigitalSuccess } from '../CustomizeOrder/containers/actions';
import { saveCurrentLocation } from '../../containers/actions';
import SpinnerComponent from '../../Common/Spinner/Spinner';
import { scrollInView } from '../../utils/common';
import { showSpinner } from "../AddressValidationPage/containers/action";
import { isMobile } from 'react-device-detect';
import '../../Common/FloatingCart/FloatingCart.css';
import styled from 'styled-components';
import { MarginSpacerM, MarginTopSpacerL } from '../Checkout/styleTag';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import ChatLink  from '../../Common/ChatLink/ChatLink';
import { digitalSaveOrder, getCheckoutFloatCart, checkout } from '../Checkout/containers/action';
import { SaveCartForDigital } from "./SaveCartDigitalModal";
import homeIcon  from '../../assets/images/homeIcon.png';



class SaveCartDigital extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableErrorMessageForInitial: false,
      enableErrorMessageForConfirmEmail: false,
      errorMessageForIntialEmail: "",
      errorMessageForConfirmEmail: "",
      errorMessageForFN:"",
      errorMessageForLN:"",
      intialEmail: props.saveCartEmail || props.businessInfo?.email || props.LQEmail ||  "",
      confirmEmail:  props.saveCartEmail ||  props.businessInfo?.email || props.LQEmail || "",
      reminderMail: true,
      sendOffersInfo: false,
      comments: "",
      radioValue: "",
      showErrorNotification: false,
      isSubmitClicked: false,
      initiateChat: false,
      endInteraction: false,
      viewMBGModal: false,
      customerEmail:"",
      agentEmail:"",
      firstName:"",
      lastName:"",
      saveCartDisable:false
    };
  }
  saveCartData = (e) => {
    const inputData = e.target.value;
    if (e.target.name == "email-address") {
      this.setState({
        customerEmail: inputData,
        errorMessageForIntialEmail: ""
      });
    }else if(e.target.name == "agent-email-address") {
      this.setState({
        agentEmail: inputData,
        errorMessageForConfirmEmail: ""
      });
    }else if(e.target.name == "firstName") {
      this.setState({
        firstName: inputData,
        errorMessageForFN:""
      });
    }else if(e.target.name == "lastName") {
      this.setState({
        lastName: inputData,
        errorMessageForLN:""
      });
    }
  };
  componentWillReceiveProps(props) {
    const { isVOCallInProgress } = props;
    if (!isVOCallInProgress && this.state.isSubmitClicked) {
      this.setState({isSubmitClicked: false});
      this.continueClick();
    }
  }

  onSubmit = () => {
    if (this.validateBothEmail()){
      this.props.digitalSaveOrder({"AgentFirstName":this.state.firstName,"AgentLastName":this.state.lastName,"AgentEmailAddress":this.state.agentEmail,"CustomerEmailAddress":this.state.customerEmail})
      this.setState({saveCartDisable:true})
    }
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    document.getElementsByClassName("global-notification")[0].style.display = "none"; // will revert once the notification issue resolved 
    window.saveCartMounted = true;
    this.props.saveCurrentLocation(window.location.pathname);
    this.setState({ initiateChat: true });
    this.setState({ endInteraction: true });
    this.props.checkout();
    this.props.getCheckoutFloatCart();
  }

  componentDidUpdate() {
    if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
      window.newrelic.interaction().end();
      this.setState({ endInteraction: false });
    }
    if (this.state.initiateChat) {
      SiteAnalytics.trackPageInfo('SaveCart');
      // this.props.getChatInfo("checkout");
      // For Chat Refresh On URL Change..
      refreshChatHashTag();
      this.setState({ initiateChat: false });
    }
  }
  btnHandler = () => {
    if (window.prevUrl && window.prevUrl?.indexOf("/customize-order") > -1) {
      this.props.updatePageLoadType('R');
      // this.props.updateIsCheckoutPageVisited('N');
      this.props.updateIsSaveCartPageVisited('Y');
      this.props.getRetrieveCartInfo({ callback: (function() {
        this.props.history.go(-1);
      }).bind(this) });
    }
    else {
      // this.props.history.push("/checkout", { from: "save-cart" })
      this.props.history.go(-1)
    }

  };
  validateBothEmail = ()=>{
    const {agentEmail,customerEmail,firstName,lastName} = this.state
    const agentemailpattern = /^(?!.*@(gmail\.com|hotmail\.com|yahoo\.com|aol\.com)$)(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const agent = this.validateEmail(agentEmail,agentemailpattern)
    const customer = this.validateEmail(customerEmail)
    const firstNameEr = !String(firstName).trim() ? "Enter a valid First Name" : ""
    const lastnameErr = !String(lastName).trim() ? "Enter a valid Last Name" : ""
    this.setState({
      errorMessageForIntialEmail: (agentEmail === customerEmail && !agent && !customer) ? "Customer & Agent email addresses cannot be the same" : customer,
      errorMessageForConfirmEmail: (agentEmail === customerEmail && !agent && !customer) ? "Customer & Agent email addresses cannot be the same" : agent,
      errorMessageForFN:firstNameEr,
      errorMessageForLN:lastnameErr
    })
    return (agent===""&&customer===""&&firstNameEr===""&&lastnameErr==="" && agentEmail !== customerEmail )
  }
  validateEmail = (inputData,agentemailpattern)=>{
    let errorMessage = ""
    if (!inputData?.trim()) {
      errorMessage = "Email must be entered."
  } else {
      const pattern = /^[\w-'_\.a-zA-Z]+@+[\w-_\.a-zA-Z]*[\w-_\.a-zA-Z]+\.((com|COM|net|NET|org|ORG|edu|EDU|mil|MIL|name|NAME|[a-z A-Z]{2})$)|(((com|COM|net|NET|org|ORG|edu|EDU|mil|MIL|name|NAME)\.[a-z A-Z]{2})$)/;
      if (!pattern.test(inputData) || (agentemailpattern && !agentemailpattern.test(inputData))) {
        errorMessage = "Please enter a valid email address."
      } else {
        errorMessage = '';
      }
  }
  return errorMessage
  }
  continueClick = () => {
    this.setState({
      enableErrorMessageForConfirmEmail: false, enableErrorMessageForIntialEmail: false
    });
    if (this.state.intialEmail !== "" && common.isValidEmail(this.state.intialEmail?.trim())) {
      if (this.state.intialEmail?.trim()?.toLowerCase() === this.state.confirmEmail?.trim()?.toLowerCase()) {
        const saveCartInfo = {
          Comments: this.state.comments,
          Disclaimer: this.state.sendOffersInfo ? 'Y' : 'N',
          EMail: this.state.confirmEmail,
          RatingSelected: this.state.radioValue,
          SkipReminderMail: this.state.reminderMail ? 'N' : 'Y'
        }
        const history = this.props.history;
        this.props.saveEmailAddress(this.state.confirmEmail)
        this.props.actions.saveCartConfirmation(saveCartInfo, history);
      }
      else {
        this.setState({
          enableErrorMessageForConfirmEmail: true,
          showErrorNotification: true,
        });
        scrollInView(".Email-Input");
      }
      // ChatAnalytics.setPurchaseTracking(this.props.getFloatCartResponse, '');
    } else {
      this.setState({
        enableErrorMessageForIntialEmail: true,
        showErrorNotification: true,
      });
      scrollInView(".Email-Input");
    }
  };


  render() {
    const { LQPost } = this.props;
    const mbgFlag = LQPost?.HSIStatus === "Y" || LQPost?.SpeedType.includes("VDSL1");
    return (
      <div className="save-cart-container">
        <SaveCartForDigital opened={this.props.saveCartSuccessForDigitalLink} cartId={this.props.LQPost?.EPSessionID} onOpenedChange={(val)=>{
          if(!val) this.props.setSaveCartDigitalSuccess(false)
        }} closeModal={()=>{
          this.props.setSaveCartDigitalSuccess(false)
          //this.props.history.push('customize-order')
      }}/>
        {(this.props.toggleLoadingSpinner) ? <SpinnerComponent /> : ""}
        <div className={`sticky-wrapper sticky'`} >
          <NavHeader
            customizeOrder={[]}
            selectedServiceVoice={null}
            // globalscope={LQPost ? LQPost : {}}
            history={this.props.history}
            globalscope={
               (this.props.getPostLqData ? this.props.getPostLqData : this.props.LQPost ? this.props.LQPost : {})
          }
          // globalscope={this.props.pageLoadType === 'R' ? (this.props.ReviewOrderLQPost ? this.props.ReviewOrderLQPost : (this.props.LQPost ? this.props.LQPost : (this.props.ReviewOrderLQPost || {}))) : (this.props.LQPost ? this.props.LQPost : (this.props.ReviewOrderLQPost || {}))}
											
            hideCart
          />
        </div>
        {this.state.saveCartDisable ?
          <div><a href="https://www.verizon.com/business/shop/replink?source=agentlink"><img src={homeIcon} alt="Verizon Digital Agent Portal" width='30px'/></a></div> :
          <TextLink
            iconPosition="left"
            onClick={(e) => {
              this.btnHandler();
            }}
            className="back-link-text mtb1"
          >
            <span className="arrow-icon">
              <Icon name="caret-left" size="small" />
            </span>
            <span>Go back</span>
          </TextLink>
        }
        {/* {this.props.saveCartSuccessForDigitalLink ? 
           <Notification type="success" >                        
                Email sent successfully.
            </Notification> 
          : <></>}       */}
        <Grid>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
              <div className="Page-Title" style={{marginBottom:'1rem'}}>
              { this.props.getPostLqData?.IsShowLiveChat && this.props.getPostLqData?.IsShowLiveChat === 'Y' && this.props.enableDigitalLink !== 'Y' &&  <ChatLink style={{ float: "right"}} />}
                <Title size="large" primitive="h1">
                  Enter your customer's <br/>information to send them their <br/>cart details
                </Title>
              </div>
              <div>
                <Body size="small" primitive="h2">
                  The customer's cart information will be saved for 20 days. No registration is necessary.
                </Body>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 4, tablet: 6 }}>
              <div className="Email-Input">
                <Input
                  id="EmailAddress"
                  label="Customer Email Address"
                  placeholder=""
                  name="email-address"
                  //width="292px"
                  onChange={this.saveCartData}
                  error={this.state.errorMessageForIntialEmail!==""}
                  errorText={this.state.errorMessageForIntialEmail}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 4, tablet: 6 }}>
              <div className="Email-Input">
                <Input
                  id="confirmEmailAddress"
                  label="Agent email Address"
                  placeholder=""
                  name="agent-email-address"
                  //width="292px"
                  error={this.state.errorMessageForConfirmEmail!==""}
                  errorText={this.state.errorMessageForConfirmEmail}
                  onChange={this.saveCartData}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 4, tablet: 6 }}>
              <div className="Email-Input">
                <Input
                  id="firstname"
                  label="Agent first name"
                  placeholder=""
                  name="firstName"
                  //width="292px"
                  onChange={this.saveCartData}
                  error={this.state.errorMessageForFN!==""}
                  errorText={this.state.errorMessageForFN}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 4, tablet: 6 }}>
              <div className="Email-Input">
                <Input
                  id="lastname"
                  label="Agent last name"
                  placeholder=""
                  name="lastName"
                  //width="292px"
                  onChange={this.saveCartData}
                  error={this.state.errorMessageForLN!==""}
                  errorText={this.state.errorMessageForLN}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <div className="Submit-Button">
              <Button onClick={this.onSubmit} disabled={this.state.saveCartDisable}>Save your cart</Button>
            </div>
          </Row>
          <MarginTopSpacerL/>
          <Row>
          <Col className="save-cart-Col-1" colSizes={{ mobile: 4, desktop: 4, tablet: 6 }}>
            <Body color="#747676" size="small">Promos, pricing, and availability in your customer's cart might change by the time they return. Check with the customer to ensure they complete the cart and don't have any questions.</Body>
          </Col>
          </Row>
          <MarginSpacerM/>
          <Row>
          <Col className="save-cart-Col-1" colSizes={{ mobile: 4, desktop: 4, tablet: 6 }}>
            <Body color="#747676" size="small">The information provided will be used in accordance with our terms and conditions set out in our Privacy Policy California residents can view our California Privacy Notice.</Body>
          </Col>
          </Row>
          <MarginTopSpacerL/>
        </Grid>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { AddressValidationPage, SaveCartPage, CustomizeOrder, CheckoutPage } = state;
  return {
    LQPost: AddressValidationPage?.addressQualificationDetails?.LQPost,
    toggleLoadingSpinner: AddressValidationPage?.toggleLoadingSpinner,
    getPostLqData: CustomizeOrder.getPostLqData,
    pageLoadType: CustomizeOrder.pageLoadType,
    LQEmail: AddressValidationPage?.emailAddress,
    businessInfo: CheckoutPage.contactInfo,
    saveCartEmail: CheckoutPage.saveCartEmail,
    isVOCallInProgress: CheckoutPage.isVOCallInProgress,
    getFloatCartResponse: CustomizeOrder.getFloatCartResponse,
    ReviewOrderLQPost: CustomizeOrder.getPostLqData,
    saveCartSuccessForDigitalLink:CustomizeOrder.saveCartSuccessForDigitalLink,
    enableDigitalLink: CustomizeOrder.enableDigitalLink
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  getChatInfo: (data) => dispatch(getChatInfo(data)),
  getRetrieveCartInfo: (data) => dispatch(getRetrieveCartInfo(data)),
  updatePageLoadType: (data) => dispatch(updatePageLoadType(data)),
  saveCurrentLocation: (data) => dispatch(saveCurrentLocation(data)),
  updateIsCheckoutPageVisited: (data) => dispatch(updateIsCheckoutPageVisited(data)),
  updateIsSaveCartPageVisited: (data) => dispatch(updateIsSaveCartPageVisited(data)),
  showSpinner: (data) => dispatch(showSpinner(data)),
  digitalSaveOrder: (data) => dispatch(digitalSaveOrder(data))  ,
  setSaveCartDigitalSuccess: (data) => dispatch(setSaveCartDigitalSuccess(data)),
  getCheckoutFloatCart: (data) => dispatch(getCheckoutFloatCart()),
  checkout: (data) => { dispatch(checkout(data)) }
});
SaveCartDigital = connect(mapStateToProps, mapDispatchToProps)(SaveCartDigital);

export default SaveCartDigital;
